import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import styled, { css } from 'styled-components';

// TYPES
import { EditDescriptionField, MadeForRegionField } from '@warehouse/title/feature-create-single-title';
import { localStorageRepositorySingleton } from '@warehouse/shared/util';

// LIBRARIES
import EditUseField from '../fields/EditUse';
import EditClassField from '../fields/EditClass';
import VersionLanguagesV2Field from '../fields/VersionLanguageV2';
import { Row } from './styles';

export const CREATE_DEFAULT_EDIT_KEY = 'create-title:create-default-edit';

/**
 * Whether "Create Default Edit" is the default action of the create-title split button.
 * Persisted as the last action the user picked; defaults to `true` when nothing is stored.
 */
export function readCreateDefaultEditPreference(): boolean {
	return localStorageRepositorySingleton.get().get(CREATE_DEFAULT_EDIT_KEY) !== 'false';
}

export function writeCreateDefaultEditPreference(preferred: boolean): void {
	localStorageRepositorySingleton.get().set(CREATE_DEFAULT_EDIT_KEY, String(preferred));
}

const SectionWrapper = styled.div(
	({ theme }) => css`
  	margin-top: ${theme.spacing(3)};
  `,
);

const FieldsWrapper = styled.div(
	({ theme }) => css`
  	margin-top: ${theme.spacing(2)};
  `,
);

interface DefaultEditSectionProps {
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	trigger: UseFormTrigger<any>;
	errors: FieldErrors<any>;
}

/**
 * The "Default Edit Fields" step. Reached only when the user picks "Create Default Edit" from the
 * action split button, so the fields are always shown — the earlier opt-in checkbox now lives in
 * that button. All fields are optional.
 */
export function DefaultEditSection({ control, errors, setValue, trigger }: DefaultEditSectionProps) {
	return (
		<SectionWrapper>
			<FieldsWrapper>
				<Row>
					<EditUseField control={control} setValue={setValue} trigger={trigger} errors={errors} canClear />
					<EditClassField control={control} setValue={setValue} trigger={trigger} errors={errors} />
				</Row>
				<Row>
					<MadeForRegionField control={control} setValue={setValue} trigger={trigger} errors={errors} />
					<VersionLanguagesV2Field control={control} setValue={setValue} trigger={trigger} errors={errors} />
				</Row>
				<Row>
					<EditDescriptionField control={control} setValue={setValue} errors={errors} />
				</Row>
			</FieldsWrapper>
		</SectionWrapper>
	);
}
